var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticStyle: { "padding-left": "1rem", "padding-right": "1rem" } },
    _vm._l(4, function (i) {
      return _c("v-card", { key: i, staticClass: "riga-card mt-5" }, [
        _c(
          "div",
          { staticClass: "pt-12 mt-2 pb-1" },
          [
            _c(
              "v-layout",
              { attrs: { wrap: "" } },
              [
                _c(
                  "v-flex",
                  { staticClass: "mt-5", attrs: { xs4: "" } },
                  [_c("v-skeleton-loader", { attrs: { type: "list-item" } })],
                  1
                ),
                _c(
                  "v-flex",
                  { attrs: { xs12: "" } },
                  [
                    _c("v-skeleton-loader", {
                      attrs: { type: "list-item-three-line" },
                    }),
                  ],
                  1
                ),
                _c(
                  "v-flex",
                  { staticClass: "mb-5", attrs: { xs3: "" } },
                  [
                    _c("v-skeleton-loader", {
                      attrs: { type: "card-heading" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ])
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }